export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_BLOCKER = 'SET_BLOCKER';
export const PAUSE_NOTIFICATIONS = 'PAUSE_NOTIFICATIONS';
export const RESUME_NOTIFICATIONS = 'RESUME_NOTIFICATIONS';

export const DEFAULT_NOTIFICATION = {
  isShown: false,
  notificationType: undefined,
  message: '',
  timeout: 5000,
  priority: 1
};

export const PRIORITIES = {
  IMPORTANT: 2,
  BLOCKER: 1.5,
  REGULAR: 1
};

export const categoryToPriorityMap = {
  CALL_TO_ACTION: PRIORITIES.REGULAR,
  RESPONSE_TO_ACTION: PRIORITIES.IMPORTANT
};

export const priorityTypeToBlockerMap = {
  REGULAR: PRIORITIES.BLOCKER
};
